import React from 'react';
import { Dialog } from "../../../../components/Dialog/Dialog";
import { DialogActions } from "../../../../components/Dialog/DialogActions";
import { DialogButton } from "../../../../components/Dialog/DialogButton";
import { DialogContent } from "../../../../components/Dialog/DialogContent";
import { DialogTitle } from "../../../../components/Dialog/DialogTitle";
import { Typography } from "../../../../components/Typography/Typography";
import { useTranslation } from "../../../../hooks/useTranslation";
import { makeStyles } from "../../../../styles/makeStyles";
var useStyles = makeStyles(function () { return ({
    content: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
}); }, { name: 'SnWorkUnavailableCourseDialog' });
export var WorkUnavailableCourseDialog = function (_a) {
    var open = _a.open, workNames = _a.workNames, onClose = _a.onClose;
    var t = useTranslation().t;
    var classes = useStyles();
    var handleRef = function (element) {
        element === null || element === void 0 ? void 0 : element.setAttribute('data-test-id', 'WorkUnavailableCourseDialog');
    };
    return (React.createElement(Dialog, { open: open, ref: handleRef },
        React.createElement(DialogTitle, null, t('ワークメーカー')),
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(Typography, { variant: "body1" }, t('教科書出版社設定が変更されたため、')),
            React.createElement(Typography, { variant: "body1" }, t('以下のワークは配付できません。')),
            React.createElement("br", null),
            React.createElement(React.Fragment, null, workNames.map(function (workName, index) {
                return (React.createElement(Typography, { key: workName + "-" + index, variant: "body1" }, workName));
            }))),
        React.createElement(DialogActions, null,
            React.createElement(DialogButton, { onClick: onClose, fill: true }, t('OK')))));
};
